import { useCallback } from "react";
import { Address, WalletClient } from "viem";
import { signAndLogin } from "../../auth";

export const useSignAndLogin = () => {
  return useCallback((walletClient: WalletClient, account: Address) => signAndLogin(walletClient, account), []);
};
